import React from 'react';
import config from 'react-global-configuration';

import type { SiteDomain } from '../../../../types';
import ActivitiesOverviewBuurtboerderij from './Buurtboerderij';
import ActivitiesOverviewRegenboog from './Regenboog';

export interface ActivitiesOverviewProps {
  display: string;
  targetAudience: 'participant' | 'volunteer'
}

const ActivitiesOverview: React.FC<ActivitiesOverviewProps> = (props) => {
  const currentDomain = config.get('CURRENT_DOMAIN') as SiteDomain;

  switch (currentDomain) {
    case 'buurtboerderij': {
      return <ActivitiesOverviewBuurtboerderij {...props} />;
    }

    case 'regenboog':
    default: {
      return <ActivitiesOverviewRegenboog {...props} />;
    }
  }
};

export default ActivitiesOverview;
